<template>
    <div class="ranking-box">
        <div :id="ttl.id" :class="ttl.class">
            <h3 class="ttl">{{ ttl.type }}{{ ttl.display }}</h3>
        </div>
        <div v-if="rankingError">
            <el-icon :size="15" color="#f16868" class="el-icon-warning" />
            ランキング情報の取得に失敗しました。
        </div>
        <div v-else class="ranking">
            <div
                v-for="(rank, index) in rankings"
                :key="index"
                :class="'row rank' + (index + 1).toString().padStart(2, '0')"
            >
                <div
                    v-bind:class="
                        'row rank' + (index + 1).toString().padStart(2, '0')
                    "
                >
                    <slot :rank="rank">
                        <a v-if="rankingtype == 'KEYWORD'" href="#">
                            {{ rank.keyword }}
                        </a>
                        <router-link v-else :to="setAccessLink(rank.url)">
                            {{ rank.title }}
                        </router-link>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { RankingTitles } from "@/store/app.config";
import RankingApiService from "@/services/RankingApiService.js";

import { defineComponent, toRef } from "vue";

export default defineComponent({
    name: "PageRanking",
    props: {
        rankingtype: {
            type: String,
            required: true,
        },
        formtype: {
            type: String,
            required: true,
        },
        searchData: {
            type: Object,
        },
    },
    async setup(props) {
        //各ランキングにおけるタイトルのデフォルト設定
        let ttl = {
            id: "keyword-ranking",
            class: "keyword-ranking",
            type: "",
            display: RankingTitles.DEFAULT,
        };
        let form_param = "";
        let detailName = "";
        let apiResponse;

        switch (props.formtype) {
            case "all":
                ttl.class = "keyword-ranking";
                ttl.type = "";
                form_param = "ALL";
                break;
            case "paper":
                ttl.class = "paper-ranking";
                ttl.type = "論文";
                form_param = "PAPER";
                detailName = "PaperMetadata";
                break;
            case "hinshu":
                ttl.class = "hinshu-ranking";
                ttl.type = "認定品種";
                form_param = "HINSHU";
                detailName = "HinshuMetadata";
                break;
            case "noukigu":
                ttl.class = "noukigu-ranking";
                ttl.type = "農機具";
                form_param = "NOUKIGU";
                detailName = "NoukiguMetadata";
                break;
            default:
                break;
        }
        let rankings = [];
        let rankingError = false;
        let paramsData = {};
        paramsData.params = {};
        paramsData.params["limit"] = 5;
        switch (props.rankingtype) {
            case "KEYWORD":
                ttl.id = "keyword-ranking";
                ttl.class = "keyword-ranking";
                ttl.display = RankingTitles.KEYWORD;
                apiResponse = await RankingApiService.getKeywordRanking(
                    form_param,
                    paramsData
                );
                break;
            case "ACCESS":
                ttl.id = "access-ranking";
                ttl.display = RankingTitles.ACCESS;
                apiResponse = await RankingApiService.getAccessRanking(
                    form_param,
                    paramsData
                );
                break;
            default:
                break;
        }

        if (apiResponse) {
            if (apiResponse.status == 204) {
                rankings = [];
            } else {
                rankings = apiResponse.data.response.results;
            }
            rankingError = false;
        } else {
            rankings = [];
            rankingError = true;
        }

        const form = toRef(props, "searchData");
        const setAccessLink = (url) => {
            let to_param = {};
            let urlAry = url.split("/");
            to_param.name = detailName;

            to_param.params = {};
            if (form.value && Object.keys(form.value).length > 0) {
                Object.entries(form.value).forEach(([key, value]) => {
                    if (typeof value == "object") {
                        if (value.length > 0) {
                            to_param.params[key] = value;
                        }
                    } else {
                        if (value != null && value != "") {
                            to_param.params[key] = value;
                        }
                    }
                });
            }

            to_param.params.id = urlAry[urlAry.length - 1];
            return to_param;
        };

        return { ttl, rankings, rankingError, setAccessLink };
    },
});
</script>

<style>
.ranking-box {
    /* border: 1px solid #bbbbbb; */
    border-top: none;
    float: right;
    /* width: 270px; */
    min-width: 240px;
    width: 95%;
}
.ranking {
    border: 1px solid #bbbbbb;
}
.ranking .row {
    border-top: 1px solid #bbbbbb;
}
.ranking .row a {
    padding: 5px 10px 4px 35px;
    display: block;
    text-decoration: underline;
    background: no-repeat 10px 8px;
}
.ranking-box .ttl {
    color: #333;
    font-size: 110%;
    font-weight: bold;
    margin-bottom: 5px;
    padding: 0 0 5px 37px;
    /* background: url("images/search_link_06.png") no-repeat scroll 0 2px; */
    background-size: 7.5%;
}

#keyword-ranking .ttl {
    color: #333;
    font-size: 110%;
    font-weight: bold;
    padding: 0 0 5px 37px;
    margin-bottom: 0;
    background: url("../../../public/images/icon_ranking.gif") no-repeat 8px 0;
}
#access-ranking .ttl {
    color: #333;
    font-size: 110%;
    font-weight: bold;
    padding: 0 0 5px 37px;
    margin-bottom: 0;
}
.paper-ranking .ttl {
    margin-bottom: 5px;
    background: url("../../../public/images/search_link_02.png") no-repeat
        scroll 0 2px;
    background-size: auto;
    background-size: 7.5%;
}
.hinshu-ranking .ttl {
    margin-bottom: 5px;
    background: url("../../../public/images/search_link_06.png") no-repeat
        scroll 0 2px;
    background-size: auto;
    background-size: 7.5%;
}
.noukigu-ranking .ttl {
    margin-bottom: 5px;
    background: url("../../../public/images/search_link_07.png") no-repeat
        scroll 0 2px;
    background-size: auto;
    background-size: 7.5%;
}

.ranking .rank01 a {
    background-image: url("../../../public/images/icon_rank_01.gif");
}
.ranking .rank02 a {
    background-image: url("../../../public/images/icon_rank_02.gif");
}
.ranking .rank03 a {
    background-image: url("../../../public/images/icon_rank_03.gif");
}
.ranking .rank04 a {
    background-image: url("../../../public/images/icon_rank_04.gif");
}
.ranking .rank05 a {
    background-image: url("../../../public/images/icon_rank_05.gif");
}

i {
    vertical-align: middle;
    margin-right: 10px;
}
</style>
